import { request } from './apiClient';
import { getSessionClientId } from './authSession';

// Lista o catálogo de tipos de concreto natos (padrão) somados aos do cliente da sessão.
export const getTipoConcreto = async (idCliente) => {
    const effectiveClientId = idCliente || getSessionClientId();
    return await request(`/api/tipoConcreto?idCliente=${effectiveClientId}`);
};

/* EXCLUIR APÓS VALIDAÇÃO
// Lista os tipos de concreto natos somados aos da empresa informada, já restritos ao cliente da sessão.
export const getTipoConcretoEmpresa = async (idEmpresa) => {
    return await request(`/api/tipoConcreto/TipoConcretoEmpresa/${idEmpresa}`);
};
*/

// Cria um tipo de concreto vinculado ao cliente da sessão.
export const createTipoConcreto = async (tipoConcretoData) => {
    return await request("/api/tipoConcreto", {
        method: 'POST',
        body: JSON.stringify(tipoConcretoData)
    });
};

// Atualiza um tipo de concreto por id.
export const updateTipoConcreto = async (idTipoConcreto, tipoConcretoData) => {
    return await request(`/api/tipoConcreto/${idTipoConcreto}`, {
        method: 'PUT',
        body: JSON.stringify(tipoConcretoData)
    });
};
// Exclui um tipo de concreto por id.
export const deleteTipoConcreto = async (idTipoConcreto) => {
    return await request(`/api/tipoConcreto/${idTipoConcreto}`, {
        method: 'DELETE'
    })
}
